import { SCRATCHCARD_DISPLAY_MODES } from './types'

export const MODE_LOOKUP = {
  [SCRATCHCARD_DISPLAY_MODES.BACKSIDE]: {
    imageField: 'back',
    propertiesField: 'backImageProperties',
  },
  [SCRATCHCARD_DISPLAY_MODES.FRONT_SCRATCHED]: {
    imageField: 'scratched',
    propertiesField: 'scratchedImageProperties',
  },
  [SCRATCHCARD_DISPLAY_MODES.FRONT_UNSCRATCHED]: {
    imageField: 'unscratched',
    propertiesField: 'unscratchedImageProperties',
  },
} as const
